document.addEventListener("DOMContentLoaded", () => {
	console.log('js-share')
	document.querySelector<HTMLElement>('.js-copy-article-link')?.addEventListener('click', (e: MouseEvent) => {
		console.log('click')
		const target = e.currentTarget as HTMLElement | null;

		console.log(target);

		if (!target) return;

		const url = target.dataset.url;

		console.log(url);
		if (!url) return;

		navigator.clipboard.writeText(url).then(() => {
			alert('Link copied');
		});
	});
})